const videoSize = window.innerWidth <= 1600 && window.innerHeight <= 900
    ? "66vh"
    : window.innerWidth <= 1440 && window.innerHeight <= 900
        ? "66vh"
        : window.innerWidth <= 1366 && window.innerHeight <= 768
            ? "67vh"
            : window.innerWidth <= 1360 && window.innerHeight <= 768
                ? "67vh"
                :window.innerWidth <= 1024 && window.innerHeight <= 768
                    ? "67vh"
                    : window.innerWidth <= 320
                        ? "77vh"
                        : window.innerWidth <= 360 && window.innerHeight < 700
                            ? "76vh"
                            : window.innerWidth <= 375 && window.innerHeight < 800
                                ? "68vh"
                                : window.innerWidth <= 384 && window.innerHeight <= 640
                                    ? "76vh"
                                    :  window.innerWidth <= 411 && window.innerHeight <= 823
                                        ? "66vh"
                                        : window.innerWidth <= 414 && window.innerHeight < 800
                                            ? "67vh"
                                            : window.innerWidth <= 375 && window.innerHeight >= 812
                                                ? "66vh"
                                                : "65vh";

export default videoSize;